import { LaravelResponse, keyToUrl } from "@dgs/core";
import axios from "axios";
import {
	DataFieldOptionResource,
	IContactDatabaseSettingsResource,
	IContactDatabaseSettingsUpdateRequest,
} from "../types/contactDatabaseSettings";

const baseKey = "contact-database-settings";

class ContactDatabaseSettingsService {
	keys = {
		getSettings: [baseKey],
		getDataFieldOptions: [baseKey, "data-fields"],
	};
	urls = {
		getSettings: keyToUrl(this.keys.getSettings),
		getDataFieldOptions: keyToUrl(this.keys.getDataFieldOptions),
	};

	getSettings = () => axios.get<LaravelResponse<IContactDatabaseSettingsResource>>(this.urls.getSettings);

	saveSettings = (values: IContactDatabaseSettingsUpdateRequest) =>
		axios.put<LaravelResponse<IContactDatabaseSettingsResource>>(this.urls.getSettings, values);

	getDataFieldOptions = () => axios.get<LaravelResponse<DataFieldOptionResource[]>>(this.urls.getDataFieldOptions);
}

export const contactDatabaseSettingsService = new ContactDatabaseSettingsService();
